import { Link } from 'react-router-dom';
import { GitBranch, MessageSquare, DollarSign } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import type { SessionMeta } from '../types';

function formatDate(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

function shortId(id: string): string {
  return id.slice(0, 8);
}

export function SessionListItem({ session }: { session: SessionMeta }) {
  return (
    <Link
      to={`/sessions/${session.sessionId}`}
      className="block card hover:border-blue-300 transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <StatusBadge status={session.status} />
            <span className="text-xs text-text-muted font-mono">
              {shortId(session.sessionId)}
            </span>
            {session.sessionType && (
              <span className="badge text-text-muted">{session.sessionType}</span>
            )}
          </div>

          <h3 className="font-medium text-sm truncate">
            {session.specTitle || 'Sem spec'}
          </h3>

          {session.branch && (
            <div className="mt-1 flex items-center gap-1 text-xs text-text-muted">
              <GitBranch size={12} />
              <span className="truncate font-mono">{session.branch}</span>
            </div>
          )}
        </div>

        <div className="text-right text-xs text-text-muted whitespace-nowrap">
          <div>{formatDate(session.lastActivityAt)}</div>
          <div className="mt-1 flex items-center justify-end gap-2">
            <span className="flex items-center gap-1">
              <MessageSquare size={11} />
              {session.messageCount}
            </span>
            <span className="flex items-center gap-1">
              <DollarSign size={11} />
              {session.totalCostUsd.toFixed(3)}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
